import { checkIfAutoplayIsAllowed } from "./check-media-autoplay-policy";

export const MiscUtils = {
    checkIfAutoplayIsAllowed,
};
